import '../styles/modal.css';
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons'

class Modal extends React.Component {
  
    render = () => {
        if(this.props.show)
        {
            return (
                <div className="modal no-print" >
                    <div className="modal-background" onClick={this.props.closeModal}></div>
                    <div className="modal-content" >
                            <button className="close" onClick={this.props.closeModal}><FontAwesomeIcon icon={faTimesCircle} className="close-icon" /></button>
                        <div className="modal-header">
                            <h2 className='modal-title'>{this.props.title}</h2>
                        </div>
                        <div className="modal-body">
                            {this.props.content}
                        </div>
                    </div>
                </div>
            );
        }
        else
        {
            return null;
        }
    }
}

export default Modal;